import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // version: "v.1.17",
    version: "2026-02-10 - 03:59 p.m.",
    user_auth: false,
    // VARIABLES DEL LOGIN
    email: null,
    email_session: null,
    session_nombre: null,
    session_apellido: null,

    // NÚMERO MAX EXPUESTOS
    n_max_expuestos: 0,

    // VARIABLES DEL NAVBAR
    show_navbar: null,

    // VARIABLES NAVBAR MATRIZ PELIGRO
    estado_navbar_matriz_peligro: null,
    estado_navbar_administrador: null,

    // VARIABLES msp
    msp_c_key: null,
    msp_c_key_cliente_iper: null,
    msp_es_proceso: false,

    // VARIABLES mip
    mip_id_proceso: null,
    mip_id_zona: null,
    mip_id_actividad: null,
    mip_id_tareas: null,

    mip_proceso: null,
    mip_zona: null,
    mip_actividad: null,
    mip_tarea: [],
    mip_rutinario: null,

    global_id_matriz_riesgo: "",
    global_es_editar: false,
    global_nuevo_peligro: false,
    global_matriz_peligro_cliente: [],
    global_matriz_peligro_cliente_movil: [],

    global_llenar_matriz_peligros: false,

    global_esAdmin: false,

    global_privilegio_admin_registro_cliente: {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    },
    global_privilegio_admin_registro_proceso: {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    },
    global_privilegio_admin_registro_peligro: {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    },
    global_privilegio_admin_registro_efecto_posible: {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    },
    global_privilegio_admin_registro_control_medida: {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    },
    global_privilegio_admin_registro_usuario: {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    },
    global_privilegio_admin_registro_regional: {
      crear: false,
      editar: false,
      eliminar: false,
      ver: false,
    },
    global_privilegio_regionales_todas: false,
    global_privilegio_matriz_peligro: {
      ver: false,
      consultar: false,
      crear: false,
      editar: false,
      eliminar: false,
      descargar_excel: false,
      copiar_matriz: false,
      control_cambio: false,
      verificacion_cyd: false,
    },
    global_privilegio_regional: [],
    global_privilegio_consulta: {
      excel: false,
      pdf: false,
      ver: false,
    },
    g_compartir_matriz: false,
    g_descargar_matriz: false,

    descargarExcelMatriz(tableMatriz, tableCambios, fileName) {
      // HELPERS
      const cssColorToARGB = (color) => {
        if (!color) return null;
        const c = String(color).trim();
        if (c === "transparent") return null;

        // rgb/rgba
        const m = c.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?\)$/i
        );
        if (m) {
          const r = Number(m[1]),
            g = Number(m[2]),
            b = Number(m[3]);
          const a = m[4] == null ? 1 : Number(m[4]);
          if (a === 0) return null;
          const hex2 = (n) =>
            n
              .toString(16)
              .padStart(2, "0")
              .toUpperCase();
          const AA = hex2(Math.round(a * 255));
          return `${AA}${hex2(r)}${hex2(g)}${hex2(b)}`;
        }

        // #RRGGBB
        const h6 = c.match(/^#([0-9a-f]{6})$/i);
        if (h6) return `FF${h6[1].toUpperCase()}`;

        // #RGB
        const h3 = c.match(/^#([0-9a-f]{3})$/i);
        if (h3) {
          const h = h3[1];
          return `FF${(h[0] + h[0] + h[1] + h[1] + h[2] + h[2]).toUpperCase()}`;
        }

        return null;
      };
      const isWhiteARGB = (argb) => {
        return (argb || "").toUpperCase() === "FFFFFFFF";
      };
      const hasInlineBackground = (cellEl) => {
        const st = (cellEl.getAttribute("style") || "").toLowerCase();
        return st.includes("background");
      };
      const smartParseNumber = (raw) => {
        const s = String(raw).trim();
        if (!s) return null;

        // Si tiene letras, no es número
        if (/[a-záéíóúñ]/i.test(s)) return null;

        // Normalizar miles/decimales típicos (COL): 1.234,56  o  1,234.56
        const hasComma = s.includes(",");
        const hasDot = s.includes(".");

        // Quitar espacios
        let x = s.replace(/\s+/g, "");

        if (hasComma && hasDot) {
          // Decidir el separador decimal por el último símbolo
          const lastComma = x.lastIndexOf(",");
          const lastDot = x.lastIndexOf(".");
          if (lastComma > lastDot) {
            // decimal = comma
            x = x.replace(/\./g, "").replace(",", ".");
          } else {
            // decimal = dot
            x = x.replace(/,/g, "");
          }
        } else if (hasComma && !hasDot) {
          // Puede ser decimal o miles; si hay 1 coma y 2-3 dígitos al final, asumimos decimal
          const m = x.match(/,(\d{1,3})$/);
          if (m) x = x.replace(",", ".");
          else x = x.replace(/,/g, "");
        } else {
          // solo punto o nada: si hay varios puntos, asumimos miles
          const dots = (x.match(/\./g) || []).length;
          if (dots >= 2) x = x.replace(/\./g, "");
        }

        if (!/^-?\d+(\.\d+)?$/.test(x)) return null;
        const n = Number(x);
        return Number.isFinite(n) ? n : null;
      };
      const thinBlackBorder = () => {
        return { style: "thin", color: { rgb: "FF000000" } };
      };
      const baseEmptyCellStyle = () => {
        const b = thinBlackBorder();
        return {
          font: { name: "Arial", sz: 10 },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
          border: { top: b, right: b, bottom: b, left: b },
        };
      };
      const ensureAllBorders = (cell) => {
        const b = thinBlackBorder();
        cell.s ??= {};
        cell.s.border ??= {};
        cell.s.border.top ??= b;
        cell.s.border.right ??= b;
        cell.s.border.bottom ??= b;
        cell.s.border.left ??= b;
      };
      const applyCellStyle = (xcell, cellEl, comp) => {
        const fontColor = cssColorToARGB(comp.color);

        // fondo calculado desde CSS/inline
        const bgARGB = cssColorToARGB(comp.backgroundColor);

        // Reglas:
        // 1) En THEAD: conservar color si NO es blanco/transparente
        // 2) En TBODY: conservar SOLO si el fondo viene explícito (inline) y NO es blanco/transparente
        const inThead = !!cellEl.closest("thead");

        const keepFill =
          bgARGB &&
          !isWhiteARGB(bgARGB) &&
          (inThead || hasInlineBackground(cellEl));

        xcell.s = {
          font: {
            name: comp.fontFamily
              ? comp.fontFamily
                  .split(",")[0]
                  .trim()
                  .replace(/['"]/g, "")
              : "Arial",
            sz: comp.fontSize
              ? Math.max(8, Math.round(parseFloat(comp.fontSize)))
              : 10,
            bold:
              cellEl.tagName === "TH" ||
              parseInt(comp.fontWeight || "400", 10) >= 600,
            italic: String(comp.fontStyle || "")
              .toLowerCase()
              .includes("italic"),
            color: fontColor ? { rgb: fontColor } : undefined,
          },
          // ✅ Solo se pone fill si realmente aplica
          fill: keepFill
            ? { patternType: "solid", fgColor: { rgb: bgARGB } }
            : undefined,
          alignment: {
            horizontal: (comp.textAlign || "").includes("right")
              ? "right"
              : (comp.textAlign || "").includes("center")
              ? "center"
              : "left",
            vertical: (comp.verticalAlign || "").includes("middle")
              ? "center"
              : (comp.verticalAlign || "").includes("bottom")
              ? "bottom"
              : "top",
            wrapText: true,
          },
          border: {
            top: { style: "thin", color: 1 },
            bottom: { style: "thin", color: 1 },
            left: { style: "thin", color: 1 },
            right: { style: "thin", color: 1 },
          },
        };
      };
      const buildStyleWorksheetFromTable = (tableEl) => {
        const ws = {};
        const merges = [];
        const occupied = new Map(); // "r,c" => true

        const colWidthsPx = [];
        const rowHeights = [];

        const key = (r, c) => `${r},${c}`;
        const rows = Array.from(tableEl.rows);

        let maxCol = 0;

        for (let r = 0; r < rows.length; r++) {
          const tr = rows[r];

          // Alto de fila: mejor con bounding rect (si la tabla está visible)
          const trRect = tr.getBoundingClientRect();
          if (trRect.height)
            rowHeights[r] = { hpx: Math.max(14, Math.round(trRect.height)) };

          let c = 0;
          for (const cell of Array.from(tr.cells)) {
            while (occupied.get(key(r, c))) c++;

            const comp = window.getComputedStyle(cell);

            // Texto con saltos de línea (div/p internos)
            const rawText = (cell.innerText ?? "")
              .replace(/\u00A0/g, " ")
              .trim();
            const maybeNum = smartParseNumber(rawText);

            const xcell =
              maybeNum != null
                ? { t: "n", v: maybeNum }
                : { t: "s", v: rawText };

            applyCellStyle(xcell, cell, comp);

            const addr = XLSX.utils.encode_cell({ r, c });
            ws[addr] = xcell;

            // Ancho de columna: usar tamaño real
            const rect = cell.getBoundingClientRect();
            const wpx = rect.width ? Math.round(rect.width) : 120;
            colWidthsPx[c] = Math.max(colWidthsPx[c] || 0, wpx);

            const colspan = Math.max(
              1,
              parseInt(cell.getAttribute("colspan") || "1", 10)
            );
            const rowspan = Math.max(
              1,
              parseInt(cell.getAttribute("rowspan") || "1", 10)
            );

            if (colspan > 1 || rowspan > 1) {
              merges.push({
                s: { r, c },
                e: { r: r + rowspan - 1, c: c + colspan - 1 },
              });

              for (let rr = r; rr <= r + rowspan - 1; rr++) {
                for (let cc = c; cc <= c + colspan - 1; cc++) {
                  if (rr === r && cc === c) continue;
                  occupied.set(key(rr, cc), true);
                }
              }
            }

            c += colspan;
            maxCol = Math.max(maxCol, c);
          }
        }

        const maxRow = rows.length;
        ws["!ref"] = XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: { r: Math.max(0, maxRow - 1), c: Math.max(0, maxCol - 1) },
        });

        if (merges.length) ws["!merges"] = merges;

        ws["!cols"] = Array.from({ length: maxCol }, (_, i) => {
          const wpx = 300;
          return { wpx };
        });

        ws["!rows"] = rowHeights;
        const emptyStyle = baseEmptyCellStyle();
        for (let r = 0; r < maxRow; r++) {
          for (let c = 0; c < maxCol; c++) {
            const addr = XLSX.utils.encode_cell({ r, c });
            if (!ws[addr]) {
              // celda faltante => existe en el rango pero no fue creada por HTML/merges
              ws[addr] = { t: "s", v: "", s: emptyStyle };
            } else {
              // celda existente => asegurar que tenga los 4 lados
              ensureAllBorders(ws[addr]);
            }
          }
        }

        if (ws["!merges"]?.length) {
          for (const m of ws["!merges"]) {
            const anchorAddr = XLSX.utils.encode_cell(m.s);
            const anchor = ws[anchorAddr];
            const styleFromAnchor = anchor?.s;

            for (let rr = m.s.r; rr <= m.e.r; rr++) {
              for (let cc = m.s.c; cc <= m.e.c; cc++) {
                const a = XLSX.utils.encode_cell({ r: rr, c: cc });
                ws[a] ??= { t: "s", v: "" };
                // Copiar estilo del ancla (sobre todo border/fill/alignment)
                ws[a].s = ws[a].s
                  ? { ...styleFromAnchor, ...ws[a].s }
                  : styleFromAnchor;
                ensureAllBorders(ws[a]);
              }
            }
          }
        }

        return ws;
      };

      // EXPORTACION DE EXCEL
      const XLSX = require("sheetjs-style");
      const wb = XLSX.utils.book_new();
      const wsm = buildStyleWorksheetFromTable(tableMatriz);
      const wsc = buildStyleWorksheetFromTable(tableCambios);

      // GENERAR ARCHIVO .XSLX
      XLSX.utils.book_append_sheet(wb, wsm, "Matriz de Peligros");
      XLSX.utils.book_append_sheet(wb, wsc, "Control de Cambios");
      XLSX.writeFile(wb, fileName);
    },
  },
  mutations: {
    mutation_limpiar_globales: (state) => {
      state.global_matriz_peligro_cliente = [];
      state.global_matriz_peligro_cliente_movil = [];

      state.mip_id_proceso = "";
      state.mip_id_zona = "";
      state.mip_id_actividad = "";
      state.mip_id_tareas = "";
      state.mip_proceso = "";
      state.mip_zona = "";
      state.mip_actividad = "";
      state.mip_tarea = [];
      state.mip_rutinario = "";
      state.global_id_matriz_riesgo = "";
      state.global_es_editar = false;
      state.global_nuevo_peligro = false;
      state.msp_c_key = "";
    },
    mutation_preparacion_botones_tabla: (state) => {
      state.global_id_matriz_riesgo = "";
      state.global_es_editar = false;
      state.global_nuevo_peligro = false;

      state.mip_id_proceso = "";
      state.mip_id_zona = "";
      state.mip_id_actividad = "";
      state.mip_id_tareas = "";
      state.mip_proceso = "";
      state.mip_zona = "";
      state.mip_actividad = "";
      state.mip_tarea = [];
      state.mip_rutinario = "";
    },
  },
  actions: {},
  modules: {},
});
